<div class="flex flex-col gap-4 min-w-0 h-full">
    @if (loading()) {
        <div class="flex items-center gap-3 shrink-0">
            <p-progress-spinner strokeWidth="5" [style]="{ width: '25px', height: '25px' }" />
        </div>
    } @else {
        <div class="donut-layout">
            <div class="donut" [style.background]="conicGradient()">
                <div class="donut-center">
                    <strong>{{ totalSales() }}</strong>
                    <span>Total sales</span>
                </div>
            </div>
            <div class="legend">
                <div class="legend-item">
                    <i style="background: #4c68df"></i>
                    <span>Admin</span>
                    <strong>{{ admin() }}</strong>
                </div>
                <div class="legend-item">
                    <i style="background: #25a9a2"></i>
                    <span>OTA</span>
                    <strong>{{ ota() }}</strong>
                </div>
                <div class="legend-item">
                    <i style="background: #a8dbd5"></i>
                    <span>IBE</span>
                    <strong>{{ ibe() }}</strong>
                </div>
            </div>
        </div>
    }
</div>
